import { action, computed, decorate, observable } from "mobx";

const SUPPORTED_SPORT_IDS = [1, 11, 12, 13, 14, 22];
const DEFAULT_SPORT_ID = 1;

class SportsReferenceStore {
  constructor(statsApi) {
    this.statsApi = statsApi;
    this._sports = [];

    this.initialize();
  }

  initialize() {
    this.loadSports();
  }

  get sports() {
    return this._sports;
  }

  get defaultSport() {
    return this.sports.length > 0 && this.sports[0]
      ? this.sports[0].id
      : DEFAULT_SPORT_ID;
  }

  loadSports() {
    return this.statsApi.getSports().then(sports => {
      this._sports = sports
        .filter(sport => SUPPORTED_SPORT_IDS.includes(sport.id))
        .map(sport => ({
          id: sport.id,
          abbreviation: sport.abbreviation
        }));
    });
  }
}

decorate(SportsReferenceStore, {
  _sports: observable,
  sports: computed,
  defaultSport: computed,
  loadSports: action
});

export default SportsReferenceStore;

